/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import axios from "axios";
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
// import config from '../../config/config';
import config from '../../../config/config';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import TrademarkBarChart from '../../TrademarkBarChart/TrademarkBarChart';
import LegalPieChart from '../../LegalPieChart/LegalPieChart';
import ComplaintDisputeChart from '../../ComplaintDisputeChart/ComplaintDisputeChart';
import ComplaintDisputeBarChart from '../../ComplaintDisputeChart/ComplaintBarChart';
import DomainTile from '../../DomainTile/DomainTile';
import styles from './MainDashboard.module.css';
import './MainDashboard.css';

// const entityOptions = [
//   { value: 'undefined', label: 'Select' },
//   { value: 'All', label: '-All-' },
//   { value: 'tmcv', label: 'TMCV' },
//   { value: 'tmpv', label: 'TMPV' },
//   { value: 'jlr', label: 'JLR' },
//   { value: 'agratas', label: 'Agratas' },
// ];

// const geographyOptions = [
//   { value: 'undefined', label: 'Select' },
//   { value: 'All', label: '-All-' },
//   { value: 'domastic', label: 'Domastic' },
//   { value: 'international', label: 'International' },
// ];

// const yearOptions = [
//   { value: 'undefined', label: 'Select' },
//   { value: 'All', label: '-All-' },
//   { value: '2025', label: '2025' },
//   { value: '2024', label: '2024' },
// ];

const quarterOptions = [
  { value: 'undefined', label: 'Select' },
  { value: 'All', label: '-All-' },
  { value: 'Q1', label: 'Q1' },
  { value: 'Q2', label: 'Q2' },
  { value: 'Q3', label: 'Q3' },
  { value: 'Q4', label: 'Q4' },
];

// const monthOptions = [
//   { value: 'undefined', label: 'Select' },
//   { value: 'All', label: '-All-' },
//   { value: 'Jan', label: 'Jan' },
//   { value: 'Feb', label: 'Feb' },
//   { value: 'Mar', label: 'Mar' },
//   { value: 'Apr', label: 'Apr' },
//   { value: 'May', label: 'May' },
//   { value: 'Jun', label: 'Jun' },
//   { value: 'Jul', label: 'Jul' },
//   { value: 'Aug', label: 'Aug' },
//   { value: 'Sep', label: 'Sep' },
//   { value: 'Oct', label: 'Oct' },
//   { value: 'Nov', label: 'Nov' },
//   { value: 'Dec', label: 'Dec' },
// ];

const { API_BASE_URL } = config;

const LegalMainDashboard = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  // console.log("roles data ----------------->", roles);
  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    // entityData: null,
    entityData: [],
    geographyData: null,
    yearData: null,
    monthData: null,
    quarterData: null,
  };

  // // ############# Start new code for user auth ##################
  // const [hasMainPageAccess, setHasMainPageAccess] = useState(true);
  // const [accessiblePages, setAccessiblePages] = useState([]);

  // useEffect(() => {
  //   if ( roles !== null ){
  //     const PagesData = roles.pages;
  //     setAccessiblePages(roles.pages);
  //     // console.log("data ---------------->", PagesData);
  //     if (roles.pages.includes("Legal MainPage")) {
  //       // alert("allowed into main page");
  //       setHasMainPageAccess(true);
  //     } else{
  //       // alert("not allow");
  //       setHasMainPageAccess(false);
  //     }
  //   }
  // }, [roles]);

  // const pageDetails = {
  //   "Trademark-Registrations-Related-Matters": {
  //     title: "Trademark Registrations",
  //     path: "/Legal-Page/Trademark-Registrations-Related-Matters"
  //   },
  //   "Trademark-Oppositions": {
  //     title: "Trademark Oppositions",
  //     path: "/Legal-Page/Trademark-Oppositions"
  //   },
  //   "Domain-Registrations-Related-Matters": {
  //     title: "Domain Registrations",
  //     path: "/Legal-Page/Domain-Registrations-Related-Matters"
  //   },
  //   "Domain-Complaints-Disputes-Status": {
  //     title: "Domain Complaints/Disputes",
  //     path: "/Legal-Page/Domain-Complaints-Disputes-Status"
  //   }
  // };

  // // ############# End new code for user auth ##################

  const [hasApplied, setHasApplied] = useState(false);
  const [filters, setFilters] = useState(initialFilters);
  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const total = 12;
  const [entityOptions, setEntityOptions] = useState([]);
  const [geographyOptions, setGeographyOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  // const [entity, setEntity] = useState(yearOptions[0]);
  const [entity, setEntity] = useState([]);
  const [geography, setgeography] = useState(yearOptions[0]);
  const [year, setYear] = useState(yearOptions[0]);
  const [quarter, setQuarter] = useState(quarterOptions[0]);
  const [month, setMonth] = useState(monthOptions[0]);

  const [totalTrademarks, settotalTrademarks] = useState('');
  const [trademarkData, setTrademarkData] = useState([]);

  const [totalDomain, settotalTotalDomain] = useState('');
  const [DomainData, setDomainData] = useState([]);

  const [treadmarkFiledBy, setTreadmarkFiledBy] = useState('');
  const [treadmarkfiledAgainst, setTreadmarkfiledAgainst] = useState('');
  const [treadmarkEntity, setTreadmarkEntity] = useState('');
  const [domainFiledBy, setDomainFiledBy] = useState('');
  const [domainfiledAgainst, setDomainfiledAgainst] = useState('');
  const [domainEntity, setDomainEntity] = useState('');

  const [totalOppositions, setTotalOppositions] = useState('');
  const [closedMatters, setClosedMatters] = useState('');
  const [filedByTML, setFiledByTML] = useState('');
  const [filedAgainstTML, setFiledAgainstTML] = useState('');
  
  const [DomainTotalOppositions, setDomainTotalOppositions] = useState('');
  const [DomainClosedMatters, setDomainClosedMatters] = useState('');
  const [DomainFiledByTML, setDomainFiledByTML] = useState('');
  const [DomainFiledAgainstTML, setDomainFiledAgainstTML] = useState('');


  const handleEntityChange = (selected) => {
    // setEntity(selected);
    setEntity(selected || []);
    setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleGeographyChange = (selected) => {
    setgeography(selected);
    setFilters(prev => ({ ...prev, geographyData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const handleQuarterChange = (selected) => {
    setQuarter(selected);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };


  const handleApply = () => {
    console.log("data entity selected --------->", entity);
    
    // const entityFilterData = entity?.value || '';
    const entityFilterData = entity.map(e => e.value);
    const geographyFilterData = geography?.value || '';
    const yearFilterData = year?.value || '';
    const monthFilterData = month?.value || '';
    const quarterData = quarter?.value || '';
    // if (entityFilterData === ''){
    if (entityFilterData.length === ''){
      return
    }
    setIsLoading(true);
    const fetchTreadmarkData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/legal-treadmark-data`, 
          { 
            selectedEntity: entityFilterData,
            selectedGeography: geographyFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData
          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          console.log("test check submit", response.data.oppositionBreakup[0].filed_against_tml);
          setTrademarkData(response.data.barData);
          settotalTrademarks(response.data.totalCount); 
          if (response.data.oppositionBreakup.length !== 0 ){
            setTreadmarkFiledBy(response.data.oppositionBreakup);
            // setTreadmarkFiledBy(response.data.oppositionBreakup[0].filed_by_tml);
            // setTreadmarkfiledAgainst(response.data.oppositionBreakup[0].filed_against_tml);
            // setTreadmarkEntity(entityFilterData);
          } else {
            setTreadmarkFiledBy(0);
            // setTreadmarkfiledAgainst(0);
            // setTreadmarkEntity(entityFilterData)
          }
        })
      } catch (error) {
        console.error('Error fetching entity options:', error);
        // showPopup({
        //   type: MESSAGE_TYPE.INFORMATION,
        //   contextText: MESSAGE_TYPE.INFORMATION,
        //   info: "Please select entity.",
        // });
      }
    };

    const fetchDomainData = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/legal-domain-data`, 
          { 
            selectedEntity: entityFilterData,
            selectedGeography: geographyFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,

          },
          {headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }},
        )
        .then((response) => {
          console.log("test check submit", response.data);
          setDomainData(response.data.barData);
          settotalTotalDomain(response.data.totalCount);
          if (response.data.oppositionBreakup.length !== 0 ){
            setDomainFiledBy(response.data.oppositionBreakup);
            // setDomainFiledBy(response.data.oppositionBreakup[0].filed_by_tml);
            // setDomainfiledAgainst(response.data.oppositionBreakup[0].filed_against_tml);
            // setDomainEntity(entityFilterData);
          } else {
            setDomainFiledBy(0);
            // setDomainfiledAgainst(0);
            // setDomainEntity(entityFilterData)
          }
        })
      } catch (error) {
        console.error('Error fetching entity options:', error);
      }
    };

    const fetchTreadMarkClosedData = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/legal-treadmark-closed-matter`,
          {
            selectedEntity: entityFilterData,
            selectedGeography: geographyFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );

        const result = response.data[0] || {};
        console.log("Closed trademark counts:", result);
        // const totalOppositions = result.tread_business_close || 0;
        // const closedMatters = result.tread_comp_close || 0;
        // const filedByTML = result.tread_comp_close_filed_by_us || 0;
        // const filedAgainstTML = result.tread_comp_close_filed_against || 0;
        const totalOppositions = result.total_cnt || 0;
        const closedMatters = result.tread_comp_close_filed_against || 0;
        const filedByTML = result.tread_comp_close_filed_by_us || 0;
        const filedAgainstTML = result.tread_comp_close_filed_against || 0;
        setTotalOppositions(totalOppositions);
        setClosedMatters(closedMatters);
        setFiledByTML(filedByTML);
        setFiledAgainstTML(filedAgainstTML);
      } catch (error) {
        console.error('Error fetching trademark closed data:', error);
      }
    };

    const fetchDomainClosedData = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/legal-domain-closed-matter`,
          {
            selectedEntity: entityFilterData,
            selectedGeography: geographyFilterData,
            selectedYear: yearFilterData,
            selectedMonth: monthFilterData,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );
        // const result = response.data;
        const result = response.data[0];
        console.log("Closed trademark counts:", result);
        // const totalOppositions = result.business_close || 0;
        // const closedMatters = result.comp_close || 0;
        // const filedByTML = result.comp_close_filed_by_us || 0;
        // const filedAgainstTML = result.comp_close_filed_against || 0;
        const totalOppositions = result.total_comp_close || 0;
        const closedMatters = result.total_comp_close || 0;
        const filedByTML = result.comp_close_filed_by_us || 0;
        const filedAgainstTML = result.comp_close_filed_against || 0;
        
        setDomainTotalOppositions(totalOppositions);
        setDomainClosedMatters(closedMatters);
        setDomainFiledByTML(filedByTML);
        setDomainFiledAgainstTML(filedAgainstTML);
        // const totalOppositions = result.find(item => item.category === "Closed Complaints")?.count || 0;
        // const closedMatters = result.find(item => item.category === "Total Domains")?.count || 0;
        // const filedByTML = result.find(item => item.category === "Total Domains")?.count || 0;
        // const filedAgainstTML = result.find(item => item.category === "Closed Complaints")?.count || 0;
        // setDomainTotalOppositions(totalOppositions);
        // setDomainClosedMatters(closedMatters);
        // setDomainFiledByTML(filedByTML);
        // setDomainFiledAgainstTML(filedAgainstTML);
      } catch (error) {
        console.error('Error fetching trademark closed data:', error);
      }
    };

    // fetchTreadmarkData();
    // fetchDomainData();
    Promise.all([fetchTreadmarkData(), fetchDomainData(), fetchTreadMarkClosedData(), fetchDomainClosedData()]).then(() => {
      setShowDashboard(true);
      setIsLoading(false);
    });
  };

  // const handleReset = () => {
  //   setEntity(entity[0]);
  //   setgeography(geography[0]);
  //   setYear(yearOptions[0]);
  //   setQuarter(quarterOptions[0]);
  //   setMonth(monthOptions[0]);
  // };

  const handleReset = () => {
    // setEntity(null);
    setEntity([]);
    setgeography(null);
    setYear(null);
    setQuarter(quarterOptions[0]);
    setMonth(null);
    setFilters({
      entityData: null,
      geographyData: null,
      yearData: null,
      quarterData: null,
      monthData: null,
    });
    setTrademarkData([]);
    setDomainData([]);
    settotalTrademarks('');
    settotalTotalDomain('');
    setShowDashboard(false);
  };


  // const trademarkData = [
  //   { label: 'Search', value: 4 },
  //   { label: 'InProgress', value: 2 },
  //   { label: 'Registered', value: 3 },
  //   { label: 'Renewed', value: 7 },
  // ];


  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setEntityOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGeoOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-geography`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setGeographyOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setMonthOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchGeoOptions();
    fetchYearOptions();
    fetchMonthOptions();
    console.log("main page filter check -------------->", filters);
  }, []);

  useEffect(() => {
    console.log("test log -------------->",entityOptions.length, geographyOptions.length, yearOptions.length, monthOptions.length);

    if (entityOptions.length && geographyOptions.length && yearOptions.length && monthOptions.length) {
      // if (filters.entityData) {
      //   const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
      //   if (ent) setEntity(ent);
      // }

      // if (filters.geographyData) {
      //   const geo = geographyOptions.find(opt => opt.value === filters.geographyData.value);
      //   if (geo) setgeography(geo);
      // }

      // if (filters.yearData) {
      //   const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
      //   if (yr) setYear(yr);
      // }

      // if (filters.monthData) {
      //   const mon = monthOptions.find(opt => opt.value === filters.monthData.value);
      //   if (mon) setMonth(mon);
      // }

      // if (filters.quarterData) {
      //   const qtr = quarterOptions.find(opt => opt.value === filters.quarterData.value);
      //   if (qtr) setQuarter(qtr);
      // }
      // #############################################
      // if (filters.entityData?.value) {
      //   const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
      //   if (ent) setEntity(ent);
      // }

      if (filters.entityData?.length) {
        const ents = entityOptions.filter(opt =>
          filters.entityData.some(f => f.value === opt.value)
        );
        setEntity(ents);
      }

      if (filters.geographyData?.value) {
        const geo = geographyOptions.find(opt => opt.value === filters.geographyData.value);
        if (geo) setgeography(geo);
      }

      if (filters.yearData?.value) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData?.value) {
        const mon = monthOptions.find(opt => opt.value === filters.monthData.value);
        if (mon) setMonth(mon);
      }

      if (filters.quarterData?.value) {
        const qtr = quarterOptions.find(opt => opt.value === filters.quarterData.value);
        if (qtr) setQuarter(qtr);
      }

      // setTimeout(() => {
      //   setHasApplied(true);
      // }, 1000);
      if (filters.entityData.length > 0) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }

      // if (entity) {
      //   setTimeout(() => {
      //     // handleApply();
      //     setHasApplied(true);
      //   }, 2000);
      // }
    }
  }, [entityOptions, geographyOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true ) {
      // alert("clicked")
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  return (
    <>
      {/* {!hasAccess ? (
        <div style={{ padding: "2rem", textAlign: "center", color: "red", fontWeight: "bold" }}>
          Access Not Provided for this Page.
        </div>
      ) : ( */}
      {/* {!hasMainPageAccess ? (
      // <div className="container mt-4">
      //   <h3 className="mb-4 text-center" style={{ color: "#0067ac" }}>
      //     You don't have access to the full Legal Dashboard.
      //   </h3>
      //   <div className="row">
      //     {accessiblePages.map((page) => {
      //       const details = pageDetails[page];
      //       if (!details) return null;
      //       return (
      //         <div key={page} className="col-md-4 mb-4">
      //           <div
      //             className="card h-100"
      //             style={{
      //               border: '1px solid #ccc',
      //               borderRadius: '10px',
      //               boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
      //               cursor: 'pointer'
      //             }}
      //             onClick={() => window.location.href = details.path}
      //           >
      //             <div className="card-body text-center">
      //               <h5 className="card-title">{details.title}</h5>
      //               <p className="card-text">Click to view {details.title}</p>
      //             </div>
      //           </div>
      //         </div>
      //       );
      //     })}
      //   </div>
      // </div>
        <div className="container mt-4">
        <h3 className="mb-4 text-center" style={{ color: "#0067ac" }}>
          You don't have access to the full Legal Dashboard.
        </h3>
        <div className="row">
          {accessiblePages.map((page) => {
            const details = pageDetails[page];
            if (!details) return null;
            return (
              <div key={page} className="col-md-4 mb-4">
                <div
                  className="legal-tile-card"
                  onClick={() => window.location.href = details.path}
                >
                  <div className="legal-tile-body">
                    <h5 className="legal-tile-title">{details.title}</h5>
                    <p className="legal-tile-text">Click to view {details.title}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

    ) : ( */}
      <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                isMulti
                value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                placeholder="Select Entity"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Geography</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={geography}
                // onChange={setgeography}
                onChange={handleGeographyChange}
                options={geographyOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptions}
                isSearchable={false}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
            
          </div>
        </div>
      )}

      {showDashboard && (
        <>
          <div>
            <div className="row">
              <div className="col-md-12">
                <DomainTile title='Trademarks' showBackButton={false}/>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-4 mb-4">
                <DashboardSection   infoIcondata={"Manual CSV DATA"} title="Trademarks Status" disableDetailView={false} detailPath="/Legal-Page/Trademark-Registrations-Related-Matters" detailState={filters}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '10px',
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold'
                  }}>
                    <div style={{
                      backgroundColor: '#cce5c0',
                      padding: '10px 20px',
                      borderTopLeftRadius: '5px',
                      borderBottomLeftRadius: '5px',
                      border: '1px solid #ccc',
                      borderRight: 'none'
                    }}>
                      <div style={{ fontSize: '14px', textAlign: 'center' }}>Total<br />Trademarks</div>
                    </div>
                    <div style={{
                      backgroundColor: '#f2f2f2',
                      padding: '10px 20px',
                      borderTopRightRadius: '5px',
                      borderBottomRightRadius: '5px',
                      border: '1px solid #ccc'
                    }}>
                      <div style={{ fontSize: '18px', textAlign: 'center' }}>{totalTrademarks}</div>
                    </div>
                  </div>
                  <TrademarkBarChart data={trademarkData} />
                </DashboardSection>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <DashboardSection   infoIcondata={"Manual CSV DATA"} title="Oppositions Split" disableDetailView={false} detailPath="/Legal-Page/Trademark-Oppositions" detailState={filters}>
                  {/* <LegalPieChart filedBy={0} filedAgainst={0} /> */}
                  {/* <LegalPieChart filedBy={treadmarkFiledBy} filedAgainst={treadmarkfiledAgainst} entityName={treadmarkEntity}/> */}
                  <LegalPieChart oppositionBreakup={treadmarkFiledBy} />
                </DashboardSection>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <DashboardSection   infoIcondata={"Manual CSV DATA"} title="Closed matters" disableDetailView={true}>
                  {/* <ComplaintDisputeChart pieData={[0, 0]}/> */}
                  <ComplaintDisputeChart pieData={[totalOppositions, closedMatters]} labelsData={['Closed as per business instructions', 'Oppositions Closed']}/>
                  {/* <ComplaintDisputeBarChart barData={[0, 0]}/> */}
                  <ComplaintDisputeBarChart barData={[filedByTML, filedAgainstTML]}/>
                </DashboardSection>
              </div>
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col-md-12">
                <DomainTile title='Domains' showBackButton={false}/>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-4 mb-4">
                <DashboardSection   infoIcondata={"Manual CSV DATA"} title="Domains Status" disableDetailView={false} detailPath="/Legal-Page/Domain-Registrations-Related-Matters" detailState={filters}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '10px',
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold'
                  }}>
                    <div style={{
                      backgroundColor: '#cce5c0',
                      padding: '10px 20px',
                      borderTopLeftRadius: '5px',
                      borderBottomLeftRadius: '5px',
                      border: '1px solid #ccc',
                      borderRight: 'none'
                    }}>
                      <div style={{ fontSize: '14px', textAlign: 'center' }}>Total<br />Doamins</div>
                    </div>
                    <div style={{
                      backgroundColor: '#f2f2f2',
                      padding: '10px 20px',
                      borderTopRightRadius: '5px',
                      borderBottomRightRadius: '5px',
                      border: '1px solid #ccc'
                    }}>
                      <div style={{ fontSize: '18px', textAlign: 'center' }}>{totalDomain}</div>
                    </div>
                  </div>
                  <TrademarkBarChart data={DomainData} />
                </DashboardSection>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <DashboardSection   infoIcondata={"Manual CSV DATA"} title="Complaint/Disputes Split" disableDetailView={false} detailPath="/Legal-Page/Domain-Complaints-Disputes-Status" detailState={filters}>
                  {/* <LegalPieChart filedBy={0} filedAgainst={0} /> */}
                  {/* <LegalPieChart filedBy={domainFiledBy} filedAgainst={domainfiledAgainst} entityName={domainEntity}/> */}
                  <LegalPieChart oppositionBreakup={domainFiledBy}/>
                </DashboardSection>
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-4">
                <DashboardSection   infoIcondata={"Manual CSV DATA"} title="Closed matters" disableDetailView={true}>
                  {/* <ComplaintDisputeChart pieData={[0, 0]}/> */}
                  <ComplaintDisputeChart pieData={[DomainClosedMatters, DomainTotalOppositions]} labelsData={['Closed as per business instructions', 'Complaint/Disputes Closed']}/>
                  {/* <ComplaintDisputeBarChart barData={[0, 0]}/> */}
                  <ComplaintDisputeBarChart barData={[DomainFiledByTML, DomainFiledAgainstTML]}/>
                </DashboardSection>
              </div>
            </div>
          </div>
        </>
        )}
      </>
      {/* )} */}
    </>
  );
};

export default LegalMainDashboard;
